// extracted by mini-css-extract-plugin
module.exports = {"container_cv":"cv_container_cv__1-dKr","item_cv":"cv_item_cv__2xRWp","title_cv":"cv_title_cv__2SxP4"};